import React, { createContext, useContext, useMemo, useState } from 'react';
import { demoProjects, getProjectById } from '../demo/projects';
import { ProjectDemoData } from '../demo/projects/types';

interface ProjectContextValue {
  currentProject: ProjectDemoData;
  currentProjectId: string;
  switchProject: (id: string) => void;
}

const ProjectContext = createContext<ProjectContextValue | undefined>(undefined);

// 全局 Current Project：顶部选择一次，所有页面统一读取
export const ProjectProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentProjectId, setCurrentProjectId] = useState(demoProjects[0].id);
  const currentProject = getProjectById(currentProjectId) ?? demoProjects[0];

  const value = useMemo(
    () => ({ currentProject, currentProjectId, switchProject: setCurrentProjectId }),
    [currentProject, currentProjectId]
  );

  return <ProjectContext.Provider value={value}>{children}</ProjectContext.Provider>;
};

export const useProject = (): ProjectContextValue => {
  const ctx = useContext(ProjectContext);
  if (!ctx) {
    throw new Error('useProject 必须在 ProjectProvider 内使用');
  }
  return ctx;
};
